import { render, staticRenderFns } from "./news-hot.vue?vue&type=template&id=695f8824&scoped=true"
import script from "./news-hot.vue?vue&type=script&lang=js"
export * from "./news-hot.vue?vue&type=script&lang=js"
import style0 from "./news-hot.vue?vue&type=style&index=0&id=695f8824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_esdk3aqwspx5xq2g2xm6lubema/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f8824",
  null
  
)

export default component.exports